import { FC } from "react";
import { PanelContentContainer } from "~/OnboardingApp/components";
import { Steps } from "./Steps";

export const LeftSection: FC = () => {
  return (
    <PanelContentContainer bg="th.yellow1">
      <Steps />
    </PanelContentContainer>
  );
};
